import React from 'react'
import StyledText from '../../components/StyledComponents/StyledText'
import { useTheme } from '../../middleware/ThemeContext'
import styled from 'styled-components';
import PreviewImage from '../../assets/images/popupImg.png';
import { Button } from '../../components/form/Button';
import { WebsiteFormValues } from '../../types/types';
import LivePreview from './LivePreview';
import { useCreateWebsiteMutation } from '../../api/pageBuilderApiSlice';
import { LoadingSpinner } from '../ui/LoadingSpinner';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../components/toast/ToastContext';

const SecLivePreview = ({ websiteDetails, isResponsive, isSetting = false }: { websiteDetails: WebsiteFormValues, isResponsive?: boolean, isSetting?: boolean }) => {
    const { theme } = useTheme();
    const [createWebsite, { isLoading }] = useCreateWebsiteMutation();
    const navigate = useNavigate();
    const showToast = useToast();



    const handleCreate = async () => {
        try {
            if (!websiteDetails) return;

            // const payload = {
            //     name: websiteDetails.websiteName,
            //     webDomain: websiteDetails.websiteURl,
            //     timeZone: websiteDetails.timezone,
            //     welcomeNote: websiteDetails.loginHeading ?? '',
            //     description: websiteDetails.loginDescription ?? '',
            //     settings: {
            //         logo: {
            //             url: websiteDetails.logo,
            //             fileName: websiteDetails.logoFileName,
            //             size: websiteDetails.logoFileSize ? String(websiteDetails.logoFileSize) : ""
            //         },
            //         metaData: {
            //             customScreen: websiteDetails.active,
            //             colorSettings: {
            //                 primaryColor: websiteDetails.primaryColor,
            //                 secondaryColor: websiteDetails.secondaryColor,
            //                 textColor: websiteDetails.textColor
            //             },
            //             font: {
            //                 primaryFont: websiteDetails.fontFamily
            //             }
            //         }
            //     }
            // };

            const payload = {
                name: websiteDetails.websiteName,
                webDomain: websiteDetails.websiteURl,
                timeZone: websiteDetails.timezone,
                welcomeNote: websiteDetails.loginHeading ?? '',
                description: websiteDetails.loginDescription ?? '',
                settings: {
                    ...(websiteDetails.logo &&
                        websiteDetails.logoFileName && {
                        logo: {
                            url: websiteDetails.logo,
                            fileName: websiteDetails.logoFileName,
                            ...(websiteDetails.logoFileSize && {
                                size: String(websiteDetails.logoFileSize)
                            })
                        }
                    }),
                    metaData: {
                        customScreen: websiteDetails.active,
                        colorSettings: {
                            primaryColor: websiteDetails.primaryColor,
                            secondaryColor: websiteDetails.secondaryColor,
                            textColor: websiteDetails.textColor
                        },
                        cookiesConsentBanner: {
                            enabled: true
                        },
                        font: {
                            primaryFont: websiteDetails.fontFamily
                        }
                    }
                }
            };



            const Response = await createWebsite(payload).unwrap();

            localStorage.removeItem('activeTabId');
            navigate('/home/builder', { state: { companyId: Response?.website?.companyId } });
        } catch (error: any) {
            // ✅ centralized error handling
            const message =
                error?.data?.message ||
                error?.error ||
                'Something went wrong while creating website';

            showToast("Website Creation Failed", message, "error");

        }
    };
    return (
        <SecCard theme={theme} isSetting={isSetting}>
            <div className={isSetting ? '' : 'p-4'}>
                {isSetting ? null :
                    <>
                        <StyledText
                            htmlTag={'h6'}
                            fontSize={isResponsive ? '16px' : '22.33px'}
                            fontWeight={700}
                            textColor={theme.CorporateTheme.colors.primary}
                            className='text-center'
                        >
                            Live Preview
                        </StyledText>
                        <StyledText
                            htmlTag={'p'}
                            fontSize={isResponsive ? '12px' : '17.88px'}
                            fontWeight={400}
                            textColor={theme.CorporateTheme.colors.textSecondary}
                            className='text-center mb-4'
                        >
                            Preview updates as you changes settings
                        </StyledText>
                    </>
                }
                <LivePreview websiteDetails={websiteDetails} isResponsive />
                {isSetting ? null : <Button
                    theme={theme}
                    $variant='customButton'
                    width='100%'
                    className='mt-5'
                    btnBg={theme.CorporateTheme.colors.primary}
                    color={theme?.CorporateTheme?.colors?.background}
                    onClick={handleCreate}
                >
                    {isLoading ? <LoadingSpinner theme={theme} size='20px' color={theme.CreateFormTheme.colors.background} /> : 'Create My Website'}
                </Button>}
            </div>
        </SecCard>
    )
}

export default SecLivePreview

export const SecCard = styled.div<{ isSetting?: boolean }>`
    background-color: ${({ theme }) => theme.colors.contentBackground};
    border:${({ isSetting, theme }) => isSetting ? 'none' : `1px solid ${theme.CorporateTheme.colors.border}`};
    border-radius: 10px;
`;

const LivePreviewCont = styled.div`
    padding: 45px 20px;
    text-align: center;
    border-radius: 20px;
    border: 1.03px solid;
background: linear-gradient(180deg, rgba(0, 80, 255, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%);

border-image-source: linear-gradient(180deg, #0050FF 0%, rgba(0, 80, 255, 0) 100%);


`;